import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";

export enum TypeDocumentPa {
  SUR_SITE = 'SUR_SITE',
  A_DISTANCE = 'A_DISTANCE',
}

export enum EtatDocumentPa {
  BROUILLON = 'BROUILLON',
  A_FAIRE_SIGNER = 'A_FAIRE_SIGNER',
  ENVOYE_VIA_DOCUSIGN = 'ENVOYE_VIA_DOCUSIGN',
  SIGNE_PARTIELLEMENT = 'SIGNE_PARTIELLEMENT',
  SIGNE = 'SIGNE',
  ARCHIVER = 'ARCHIVE',
  ATTENTE_DE_RELECTURE = 'ATTENTE_DE_RELECTURE',
  INVALIDE = 'INVALIDE',
}

export enum CategoriePa {
  EOL = 'EOL',
  PV = 'PV',
}

export class DocumentPersonneAvertie {
  id!: number;
  numeroPa!: string;
  description!: string;
  commune!: string;
  dateDebut!: number[] | LocalDate | null;
  dateFin!: number[] | LocalDate | null;
  duree!: number | null;
  horaires!: string;
  nombreIntervenants: number | null = null;
  etat!: EtatDocumentPa;
  lien!: string;
  typePa!: TypeDocumentPa;
  actif!: boolean;
  obsolete!: boolean;
  version!: number;
  versionTechnique!: number;
  lastCompletedStep!: number;
  
  parcIds: number[] = [];
  
  categorie!: CategoriePa;
  responsableId!: number;
  
  duplicatedId!: number;
}
